import React from 'react';
import { motion } from 'framer-motion';
export const Quote: React.FC = () => {
  return <section className="py-32 bg-primary text-white relative overflow-hidden gloss-dark" data-id="element-401">
      {/* Abstract background element */}
      <div className="absolute -top-64 -right-64 w-[800px] h-[800px] rounded-full border border-surface/5" data-id="element-402" />
      <div className="absolute -bottom-64 -left-64 w-[600px] h-[600px] rounded-full border border-surface/5" data-id="element-403" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-404">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-405">
          <div className="text-leaf font-display text-8xl leading-none mb-6 opacity-70" data-id="element-406">
            "
          </div>
          <h3 className="font-display text-3xl md:text-5xl leading-tight mb-12 max-w-4xl mx-auto" data-id="element-407">
            We used to cut a big check for packaging every quarter, then watch
            most of it vanish out in the field. With CycleBox we stopped buying
            and started borrowing. The cash stayed in the business, and for once
            our sustainability story is one we can actually back up.
          </h3>

          <div className="flex items-center justify-center gap-4" data-id="element-408">
            <div className="w-12 h-12 rounded-full bg-leaf/20 border border-leaf/40 flex items-center justify-center" data-id="element-409">
              <span className="font-display text-xl text-leaf" data-id="element-410">M</span>
            </div>
            <div className="text-left" data-id="element-411">
              <div className="font-medium text-lg" data-id="element-412">Marcus Holloway</div>
              <div className="text-white/60 text-sm font-mono" data-id="element-413">
                Head of Operations, Northbrook Beverage Group
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};